<template>
    <MainContent title="Crear frecuencia">
        <template v-slot:header>
            <h3 class="card-title">Crear Frecuencia</h3>
        </template>
        <template v-slot:content>
            <div class="row" v-if="!loading">
                <div class="col-12">
                    <FormFrecuencia :frecuencia="frecuencia" @terminado="crearFrecuencia"/>
                </div>
            </div>
        </template>
    </MainContent>
</template>

<script>
    import MainContent from "@/components/backend/components/MainContent";
    import FormFrecuencia from '@/components/backend/bases/categorias/frecuencias/FormFrecuencia';

    export default {    
        data() {
            return {
                frecuencia: {},
                loading: false
            }
        },
        computed: {
            lista_id() {
                return this.$store.getters.getListaId;
            },
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.crearFrecuencia();
                }
            },
            crearFrecuencia() {
                this.loading = true;

                this.frecuencia.filters = {};
                this.frecuencia.lista_id = this.lista_id;

                this.$store.dispatch(this.config.getVuexAlias('back.frecuencias.crear'), this.frecuencia).then(res => {
                    this.$toast.success(res.data.message);
                    this.$router.push({ name: 'back.frecuencias' });
                }).finally(() => this.loading = false);
            },
        },
        components: {
            MainContent, FormFrecuencia
        }
    }
</script>
